/*eslint-disable */

import {bus} from '@/main';
import carousel from 'vue-owl-carousel';
import countries from '@/services/country.json'
import dataInstructionPopup from '@/components/dataset/data-instruction-popup/';
import deleteDataPopup from './delete-data-popup/';
import {
mapGetters
} from 'vuex';
import orgBasedDataList from './data-list-based-on-org/';
import restoreDataPopup from './restore-data-popup/';
import sharedDataList from './shared-data-list/';
import sharedDatasetPopup from '@/components/dataset/data-shared-popup/';
import updateDataPopup from '../update-algo-data-details/';
import uploadDataPopup from '../create-algo-data-details/';

const $ = window.jQuery = require('jquery');
export default {
name: 'algo-dashboard',
components: {
  carousel,
  'upload-data-popup' : uploadDataPopup,
  'update-date-popup' : updateDataPopup,
  'org-based-data-list' : orgBasedDataList,
  'delete-data-popup' : deleteDataPopup,
  'restore-data-popup' : restoreDataPopup,
  'shared-data-list' : sharedDataList,
  'shared-dataset-popup' : sharedDatasetPopup,
  'data-instruction-popup' : dataInstructionPopup
},
props: [],
data() {
  return {
    userProfileDetails: null,
    pro_payment: false,
    auto_payment: false,
    regular_payment: false,
    filterTabsChangedState: 'public_data',
    userFilterInfoData: '',
    userFilterInfoPopupState: false,
    userFilterInfoPopupStateClass: false,
    orgPublicBasedData:null,
    orgPublicBasedDataResults:[],
    orgPrivateBasedData:null,
    orgPrivateBasedDataResults:[],
    uploadDataPopupState:false,
    countryList:[],
    myListData:null,
    myListDataResults:[],
    updateAlgoDataPopupState:false,
    updateAlgoDataId:'',
    catStateProp:'',
    restoreDataState:false,
    deletePopupState:false,
    deleteDataId:'',
    deletedDataList:null,
    deletedDataListArr:[],
    restoreDataId:'',
    sharedDataFilter:'',
    sharedDatasetPopupState:false,
    sharedDatasetInfo:null,
    dataInstructionPopupState:false
  }
},
computed: {
  ...mapGetters([
    'acUserDetailsStateGetters',
  ]),
  getUserDetailsInfo() {
    this.userProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
    return
  },
  getUserDetailsIntialState() {
    if (this.userProfileDetails) {
      this.pro_payment = this.userProfileDetails.pro_payment
      this.auto_payment = this.userProfileDetails.auto_payment
      this.regular_payment = this.userProfileDetails.regular_payment
    }
  },
},
mounted() {
  Object.keys(countries).map((key, index) => {
    this.countryList.push({
      name: countries[key].toLowerCase(),
      value: key.toLowerCase()
    })
  });
  this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
  bus.$on('createAlgoDataPopupBus', (data) => {
    this.uploadDataPopupState = data;
    this.getMyDataListMethod();
  });
  bus.$on('updateAlgoDataPopupBus', (data) => {
    this.updateAlgoDataPopupState = data;
    this.getMyDataListMethod();
  });
  this.getUserDetailsInfo;
  this.getUserDetailsIntialState;
  this.getOrgPublicBasedDataMethod();
  this.getOrgPrivateBasedDataMethod();
  this.getMyDataListMethod();
  this.getDeletedDataListMethod();
  bus.$on('restoreDataStateBus', (data) => {
    this.restoreDataState = data;
    this.getMyDataListMethod();
    this.getDeletedDataListMethod();
  });
  bus.$on('deletePopupStateBus', (data) => {
    this.deletePopupState = data;
    this.getMyDataListMethod();
    this.getDeletedDataListMethod();
  });
  bus.$on('sharedDatasetStateBus', (data) => {
    this.sharedDatasetPopupState = data;
  });
  bus.$on('dataInstructionPopupStateBus', (data) => {
    this.dataInstructionPopupState = data;
  });
},
methods: {
  dataInstructionPopupMethod(){
    this.dataInstructionPopupState = true
    document.body.classList.add('body_right_scroll_remove')
  },
  deleteDataFromListMethod(id){
    this.deletePopupState = true
    this.deleteDataId = id
    document.body.classList.add('body_right_scroll_remove')
  },
  restoreDataMethod(id){
    this.restoreDataId = id
    document.body.classList.add('body_right_scroll_remove')
    this.restoreDataState = true
  },
  sharedDatasetMethod(data){
    document.body.classList.add('body_right_scroll_remove')
    this.sharedDatasetPopupState = true
    this.sharedDatasetInfo = data
  },
  updateAlogDataDetailsMethod(algoId){
    document.body.classList.add('body_right_scroll_remove')
    this.updateAlgoDataPopupState = true
    this.updateAlgoDataId = algoId
  },
  uploadDataPopupOpenMethod(){
    document.body.classList.add('body_right_scroll_remove')
    this.uploadDataPopupState = true
  },
  getMyDataListMethod(){
    this.$store.dispatch('getAlgoDataListAction').then((res) => {
      this.myListData = res.data
      this.myListDataResults = this.myListData.data
    })
  },
  getDeletedDataListMethod(){
    this.$store.dispatch('deletedDataListAction').then((res) => {
      this.deletedDataList = res.data
      this.deletedDataListArr = this.deletedDataList.data
    })
  },
  getOrgPublicBasedDataMethod(){
    this.$store.dispatch('getPublicAlgoDataBasedOrgAction').then((res) => {
      this.orgPublicBasedData = res.data.data
      this.orgPublicBasedDataResults = this.orgPublicBasedData.results
    })
  },
  getOrgPrivateBasedDataMethod(){
    this.$store.dispatch('getPrivateAlgoDataBasedOrgAction').then((res) => {
      this.orgPrivateBasedData = res.data.data
      this.orgPrivateBasedDataResults = this.orgPrivateBasedData.results
    })
  },
  clickedOutside() {
    this.userFilterInfoPopupStateClass = false
    setTimeout(() => {
      this.userFilterInfoPopupState = false
      document.body.classList.remove('body_right_scroll_remove')
      this.userFilterInfoData = ''
      this.catStateProp = ''
    }, 600);
  },
  filterTabsChangesMethod(arg){
    this.filterTabsChangedState = arg
    $('.total_count_box').removeClass('active')
    $('#filtered' + arg).addClass('active')
  },
  sharedDataFilterMethod(catState) {
    this.catStateProp = catState
    $(window).scrollTop(0);
    this.userFilterInfoPopupState = true
    document.body.classList.add('body_right_scroll_remove')
    setTimeout(() => {
      this.userFilterInfoPopupStateClass = true
    }, 10);
  },
  userFiltersInfoPopupMethod(data, catState) {
    this.catStateProp = catState
    this.userFilterInfoData = data
    $(window).scrollTop(0);
    this.userFilterInfoPopupState = true
    document.body.classList.add('body_right_scroll_remove')
    setTimeout(() => {
      this.userFilterInfoPopupStateClass = true
    }, 10);
  },
  getCountryFlag (countryCode, type) {
    if (countryCode == null) {
      countryCode = ''
    }
    let countryName = countryCode.toLowerCase()
    let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
    if (country && country.length > 0) {
      country = country[0]
      if (type == 'flag') {
        country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
      } else {
        country = country.name
      }
    } else {
      country = ''
    }
    return country;
  },
  selectedAlgoDataDetailsByIdMethod(dataId){
    this.$store.dispatch('getAllPubAlgoDataListByIdAction',{id:dataId}).then((res)=>{
      this.downloadFileMethod(res.data.data.data_file,res.data.data.data_file_name)
    }).catch((err)=>{

    })
  },
  downloadFileMethod(file,fileName){
    var link = document.createElement('a');
    link.href = file
    link.download =  fileName;
    document.body.appendChild(link);
    link.click();
  },
},
watch: {
  getUserDetailsInfo() {
    return this.$store.getters.acUserDetailsStateGetters;
  },
  getUserDetailsIntialState() {
    if (this.userProfileDetails) {
      this.pro_payment = this.userProfileDetails.pro_payment
      this.auto_payment = this.userProfileDetails.auto_payment
      this.regular_payment = this.userProfileDetails.regular_payment
    }
  },
},
beforeCreate: function () {},
beforeRouteLeave: function (to, from, next) {
  $("body").removeClass("body_right_scroll_remove");
  document.body.classList.remove('body_right_scroll_remove')
  next();
},
}